import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import formatPhone from "constants/formatPhone";

const checkboxWrap = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: 14,
    background: "#3a3a3a",
    padding: "12px 16px",
    borderRadius: "12px",
    cursor: "pointer",
    border: "1px solid rgba(255,255,255,0.12)"
};

const checkboxBox = (checked) => ({
    width: 20,
    height: 20,
    borderRadius: 6,
    border: checked ? "2px solid #ffd86b" : "2px solid #888",
    background: checked ? "#ffd86b" : "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    fontSize: 14,
    fontWeight: 700,
    transition: "0.15s"
});

export default function RequestDocumentModal({ isOpen, toggle, user, file, files = [] }) {
    const [emailChecked, setEmailChecked] = useState(true);
    const [smsChecked, setSmsChecked] = useState(true);
    const [phoneChecked, setPhoneChecked] = useState(false);
    const [customPhone, setCustomPhone] = useState("");

    const isMulti = files && files.length > 0;

    const send = () => {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");

        console.log("SEND REQUEST:", {
            user_id: user.id,
            token: authUser.token,

            mode: isMulti ? "multi" : "single",

            // single-file
            file_id: !isMulti ? file?.id : null,
            title: !isMulti ? file?.file_title || file?.type : null,

            // multiple
            documents: isMulti ? files : [],

            email_to: emailChecked ? user.email : null,
            sms_to_user_phone: smsChecked ? user.phone_number : null,
            sms_to_custom_phone: phoneChecked ? customPhone : null
        });

        toggle();
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            contentClassName="custom-dark-modal"
            style={{ maxWidth: 500 }}
        >
            <ModalBody
                style={{
                    background: "#262523",
                    borderRadius: 12,
                    padding: "28px 26px",
                    color: "white"
                }}
            >

                {/* Modal Title */}
                <h3 style={{ textAlign: "center", marginBottom: 20, fontWeight: 700, color: "#ffd86b" }}>
                    {isMulti ? "Request Multiple Documents" : "Request Document"}
                </h3>

                {isMulti && (
                    <div style={{ color: "#ccc", textAlign: "center", marginBottom: 15 }}>
                        {files.map((d, i) => (
                            <div key={i}>• {d}</div>
                        ))}
                    </div>
                )}

                {!isMulti && file && (
                    <div style={{ color: "#ccc", textAlign: "center", marginBottom: 15 }}>
                        • {file?.file_title || file?.type || "Document"}
                    </div>
                )}

                {/* Email Checkbox */}
                <div
                    style={checkboxWrap}
                    onClick={() => setEmailChecked(!emailChecked)}
                >
                    <div style={checkboxBox(emailChecked)}>
                        {emailChecked ? "✓" : ""}
                    </div>
                    <div>Email to {user.email}</div>
                </div>

                {/* SMS to user phone */}
                <div
                    style={checkboxWrap}
                    onClick={() => setSmsChecked(!smsChecked)}
                >
                    <div style={checkboxBox(smsChecked)}>
                        {smsChecked ? "✓" : ""}
                    </div>
                    <div>Text message to {formatPhone(user.phone_number)}</div>
                </div>

                {/* Custom number checkbox */}
                <div
                    style={checkboxWrap}
                    onClick={() => setPhoneChecked(!phoneChecked)}
                >
                    <div style={checkboxBox(phoneChecked)}>
                        {phoneChecked ? "✓" : ""}
                    </div>
                    <div>Text message to custom number</div>
                </div>

                {/* Custom phone input */}
                {phoneChecked && (
                    <div style={{ marginTop: 12 }}>
                        <PhoneInput
                            value={customPhone}
                            onChange={setCustomPhone}
                            country="us"
                            inputStyle={{
                                width: "100%",
                                background: "#3a3a3a",
                                color: "white",
                                border: "1px solid rgba(255,255,255,0.15)"
                            }}
                            buttonStyle={{
                                background: "#3a3a3a",
                                border: "1px solid rgba(255,255,255,0.15)"
                            }}
                            dropdownStyle={{
                                background: "#2f2f2f",
                                color: "white"
                            }}
                        />
                    </div>
                )}

                {/* Send Button */}
                <Button
                    onClick={send}
                    style={{
                        marginTop: 24,
                        width: "100%",
                        background: "#ffd86b",
                        color: "#000",
                        fontWeight: 700,
                        border: "none",
                        padding: "12px 0",
                        borderRadius: 10,
                        fontSize: 16,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.25)"
                    }}
                >
                    Send Request
                </Button>

            </ModalBody>
        </Modal>
    );
}